interface LeadSource {
  originalSource: string | null
  utmSource: string | null
}

const OUTBOUND_SOURCE = 'close' // Close CRM → the lead came from an outbound sales touch

function clean(source: string | null | undefined) {
  return source?.trim() || '' // null / "" / "   " all collapse to "missing"
}

export function getLeadSourceLabel(lead?: LeadSource | null) {
  // first-touch wins; the UTM tag is only a fallback for leads with no original source
  const source = clean(lead?.originalSource) || clean(lead?.utmSource)

  if (source.toLowerCase() === OUTBOUND_SOURCE) return 'Outbound'

  return source || 'Direct'
}
